export const socialData = {
  contactInfo: {
    phone: {
      label: 'Phone',
      value: '+91 999267742',
      url: 'tel:+91999267742',
      icon: 'FaPhone'
    },
    email: {
      label: 'Email',
      value: 'info@astrointeriors.in',
      url: 'mailto:info@astrointeriors.in',
      icon: 'FaEnvelope'
    },
    location: {
      label: 'Location',
      value: 'Noida Sector 59, Uttar Pradesh, India - 201301',
      icon: 'FaMapMarkerAlt'
    }
  },
  socialLinks: [
    {
      name: 'Facebook',
      url: 'https://facebook.com/skillyatra',
      icon: 'FaFacebookF',
      color: '#4267B2'
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/skillyatra',
      icon: 'FaTwitter',
      color: '#1DA1F2'
    },
    {
      name: 'Instagram',
      url: 'https://instagram.com/skillyatra.in',
      icon: 'FaInstagram',
      color: '#E1306C'
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/company/skillyatra-in/',
      icon: 'FaLinkedinIn',
      color: '#0077B5'
    },
    {
      name: 'YouTube',
      url: 'https://youtube.com/c/skillyatra',
      icon: 'FaYoutube',
      color: '#FF0000'
    }
  ]
};
